export const DAYS_OF_WEEK = [
	'Sunday', 'Monday', 'Tuesday', 'Wednesday',
  'Thursday', 'Friday', 'Saturday'
];


// WEBPACK FOOTER //
// ./src/modules/Schedule/components/Calendar/constants.js